module["exports"] = [
  "майдан"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/address/street_suffix.js
// module id = 1422
// module chunks = 0